import { Meta, Title } from '@angular/platform-browser';
import { Component } from '@angular/core';
import { services } from '../../services';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslationService } from '../../../../../../shared/services/translations.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-marvel-leveling',
  templateUrl: './marvel-leveling.component.html'
})
export class MarvelLevelingComponent {
  service = 'leveling';
  availableServices = services['marvel'].filter(service => service.service !== this.service);

  serviceParams = {
    game: 'marvel',
    service: 'leveling',
    type: 'solo',
    queue: 'quick',
    title: {
      en: 'Account Leveling',
    },
    subtitle: {
      en: 'Guaranteed Account Level in Solo or Duo Boosting',
      fr: 'Niveau de compte garanti en Solo ou Duo Boosting',
      de: 'Garantiertes Kontolevel im Solo- oder Duo-Boosting',
      pt: 'Nível da conta garantido em Solo ou Duo Boosting',
      es: 'Nivel de cuenta garantizado tanto en Solo como en Duo Boosting',
    },
    start: 1,
    desired: 15,
    min: 1,
    max: 14
  };

  serviceFaqs = {
    en: [
      {
        question: "What Is A Leveling Boosting Service?",
        answer: "It is a guaranteed service that allows you to reach level 10 and unlock competitive games."
      },
      {
        question: "In Which Game Mode Is Leveling Played?",
        answer: "Account Leveling is played in Quick until level 10 is reached."
      },
      {
        question: "Can I Play With The Booster In Duo Queue Boosting?",
        answer: "Indeed, you can. To accomplish this, go to the order customization menu and select \"Duo\" before clicking \"Buy Boost Now\"."
      },
      {
        question: "Can I Choose My Preferred Heroes and Roles?",
        answer: "Yes, you can. Click the \"Choose your Roles\" and \"Choose your Heroes\" options in the order customization menu to make it happen."
      },
      {
        question: "Can I Play While The Order Is Active?",
        answer: "Yes, unless you want to queue in the same game mode as the bought service. Other than that, schedule it in the order chat with your booster."
      },
      {
        question: "Can I Request The Same Booster For A Future Purchase?",
        answer: "Yes! Click the heart icon inside the order dashboard to favorite a booster, then easily reassign them to your future orders."
      }
    ],
    fr: [
      {
        question: "Qu\'est-ce qu\'un service de boosting de leveling?",
        answer: "Il s\'agit d\'un service garanti qui vous permet d\'atteindre le niveau 10 et de débloquer les parties compétitives."
      },
      {
        question: "Dans quel mode de jeu le Leveling est-il joué?",
        answer: "Le Leveling est joué en file rapide jusqu\'à ce que le niveau 10 soit atteint."
      },
      {
        question: "Puis-je jouer avec le Booster en Boosting Duo?",
        answer: "En effet, vous pouvez le faire. Pour ce faire, allez dans le menu de personnalisation de la commande et sélectionnez \"Duo\" avant de cliquer sur \"Acheter Boost maintenant\"."
      },
      {
        question: "Puis-je choisir mes héros et rôles préférés ?",
        answer: "Oui, vous pouvez. Cliquez sur les options « Choisir vos rôles » et « Choisir vos héros » dans le menu de personnalisation de commande pour le faire."
      },
      {
        question: "Puis-je jouer pendant que la commande est active?",
        answer: "Oui, sauf si vous souhaitez vous mettre en file d\'attente dans le même mode de jeu que le service acheté. Autrement, planifiez-le dans le chat de commande avec votre booster."
      },
      {
        question: "Puis-je demander le même booster pour un prochain achat?",
        answer: "Oui ! Cliquez sur l\'icône en forme de cœur dans le tableau de bord de commande pour ajouter un booster en favori, puis réassignez-le facilement à vos prochaines commandes."
      }
    ],
    de: [
      {
        question: "Was ist ein Leveling-Boosting-Service?",
        answer: "Es handelt sich um einen garantierten Service, der es dir ermöglicht, Stufe 10 zu erreichen und Wettbewerbsspiele freizuschalten."
      },
      {
        question: "In welchem Spielmodus wird das Leveling gespielt?",
        answer: "Das Account-Leveling wird in Blind/Quickplay bis Stufe 10 und dann in Draft Queue gespielt."
      },
      {
        question: "Kann ich mit dem Booster im Duo Queue Boosting spielen?",
        answer: "Ja, das kannst du. Gehe dazu in das Menü zur Bestellungsanpassung und wähle \"Duo\" aus, bevor du auf \"Boost Jetzt Kaufen\" klickst."
      },
      {
        question: "Kann ich meine bevorzugten Helden und Rollen wählen?",
        answer: "Ja, das können Sie. Klicken Sie im Bestellungsanpassungsmenü auf die Optionen „Wähle deine Rollen“ und „Wähle deine Helden“, um dies zu tun."
      },
      {
        question: "Kann ich spielen, während die Bestellung aktiv ist?",
        answer: "Ja, es sei denn, Sie möchten in demselben Spielmodus wie der gekaufte Service in die Warteschlange gehen. Ansonsten planen Sie es im Bestellungschat mit Ihrem Booster."
      },
      {
        question: "Kann ich denselben Booster auch für einen späteren Kauf anfordern?",
        answer: "Ja! Klicke im Bestell-Dashboard auf das Herzsymbol, um einen Booster zu deinen Favoriten hinzuzufügen, und weise ihn dann ganz einfach zukünftigen Bestellungen zu."
      }
    ],
    pt: [
      {
        question: "O que é um serviço de leveling?",
        answer: "É um serviço garantido que te permite alcançar nível 10 e desbloquear jogos competitivos."
      },
      {
        question: "Em que modo de jogo é feito o leveling?",
        answer: "O leveling é feito em Quick até atingir o nível 10."
      },
      {
        question: "Posso Jogar com o Booster em Duo Queue?",
        answer: "Sim, podes. Para isso, vai ao menu de personalização do pedido e seleciona 'Duo' antes de clicar em 'Comprar Boost Agora'."
      },
      {
        question: "Posso escolher meus Heroes e Roles preferidos",
        answer: "Sim, podes. Cliqua nos botões 'Escolhe os teus Roles' e 'Escolhe os teus Heroes' no menu de personalização do pedido para fazer isso."
      },
      {
        question: "Posso Jogar Enquanto O Serviço Está Activo?",
        answer: "Sim, a menos que queiras jogar no mesmo modo de jogo que o serviço comprado. Para além disso, agenda com o teu booster no chat do serviço."
      },
      {
        question: "Posso escolher o mesmo Booster para uma compra futura?",
        answer: "Sim! Clica no ícone de coração dentro do painel do pedido para marcar um booster como favorito e depois escolhe-o facilmente nos teus próximos pedidos."
      }
    ],
    es: [
      {
        question: "¿Qué es un servicio de Boost de Leveling?",
        answer: "Es un servicio garantizado que te permite alcanzar el nivel 10 y desbloquear partidas competitivas."
      },
      {
        question: "¿En qué modo de juego se juega a subir de nivel?",
        answer: "El Boost de Leveling se juega en la cola de partidas rápidas hasta alcanzar el nivel 10."
      },
      {
        question: "¿Puedo jugar con los boosters en Duo Queue Boosting?",
        answer: "Efectivamente, puedes hacerlo. Para ello, ve al menú de personalización del pedido y selecciona \"Duo\" antes de hacer clic en \"Comprar Boost ahora\"."
      },
      {
        question: "¿Puedo elegir mis héroes y roles preferidos?",
        answer: "Sí, puedes. Haz clic en las opciones \"Elegir tus Roles\" y \"Elegir tus Héroes\" en el menú de personalización del pedido para hacerlo."
      },
      {
        question: "¿Puedo jugar mientras la orden está activa?",
        answer: "Sí, a menos que quieras hacer cola en el mismo modo de juego que el servicio comprado. De lo contrario, prográmalo en el chat de la orden con tu booster."
      },
      {
        question: "¿Puedo solicitar el mismo booster para una futura compra?",
        answer: "¡Sí! Haz clic en el ícono de corazón dentro del panel del pedido para añadir un booster a favoritos y así poder reasignarlo fácilmente en tus futuros pedidos."
      }
    ]
  }

  private page = {
    title: {
      en: "Marvel Rivals Boosting - Account Level Boosting for League of Legends",
      fr: "Marvel Rivals Boosting - Boosting de montage de niveau sur League of Legends",
      de: "Marvel Rivals Boosting - Account Level Boosting für League of Legends",
      pt: "Marvel Rivals Boosting - Aumento de Nível de Conta para League of Legends",
      es: "Marvel Rivals Boosting - Boosting de nivel de cuenta para League of Legends",
    },
    metaDescription: {
      en: "Account Leveling, the fastest way to earn the leveling rewards and other loot at affordable prices. Get your order started now!",
      fr: "Leveling de compte, le moyen le plus rapide de gagner les récompenses de niveau et d\'autres loots à des prix abordables. Passez votre commande dès maintenant!",
      de: "Account Leveling, der schnellste Weg zu Leveling-Belohnungen und anderer Beute zu günstigen Preisen. Jetzt bestellen!",
      pt: "Leveling de Conta, a maneira mais rápida de ganhar recompensas de leveling e outros itens a preços acessíveis. Começa o teu pedido agora!",
      es: "Account Leveling, la forma más rápida de ganar las recompensas de subida de nivel y otros botines a precios asequibles. ¡Empieza ya tu pedido!",
    }
  }

  lang: string = 'en';

  constructor(meta: Meta, title: Title, private route: ActivatedRoute, private router: Router, private cookie: CookieService, private translationService: TranslationService,) {
    this.route.params.subscribe(params => {
      if (Object.keys(params).length === 0) {
        const url = this.router.url.split('/');
        if (this.translationService.validLangs.includes(url[1])) {
          this.lang = url[1];
        } else {
          this.lang = this.cookie.get('gg-lang') || 'en';
        }
      } else {
        this.lang = params['lang'] || 'en';
      }

      title.setTitle(this.page.title[this.lang] || this.page.title['en']);
      meta.updateTag(
        {
          name: 'description',
          content: this.page.metaDescription[this.lang] || this.page.metaDescription['en']
        }
      );
    });
  }
}